import { BALANCE_CONSUMED_API } from "../../constants/constants"
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor"
import { AverageConsumedBalanceFailure, AverageConsumedBalanceSuccess } from "./reducer"

export const AverageConsumedBalance = (setLoading, customerId) => async (dispatch) => {
    setLoading(true)
    const graphqlQuery = {
        query: "query AverageConsumedBalance($customerId: String!) {\n  AverageConsumedBalance(customerId: $customerId)\n}",
        variables: { customerId: customerId}
    }

    try {
        const response = await determineBaseUrlAndPerformApiCall(
            `${BALANCE_CONSUMED_API}`,
            'POST',
            graphqlQuery
        );
        setLoading(true)
        const AverageConsumedBalance = response?.data
        dispatch(AverageConsumedBalanceSuccess(AverageConsumedBalance))
    } catch (error) {
        dispatch(AverageConsumedBalanceFailure(error.message))
    } finally {
        setLoading(false)
    }
}

